import React, {
  useEffect,
} from 'react';

import { LoginByPhoneFormStep1 } from './LoginByPhoneFormStep1';
import { LoginByPhoneFormStep2 } from './LoginByPhoneFormStep2';
import { LoginByPhoneFormStep3 } from './LoginByPhoneFormStep3';

import { Stepper } from '../../../../../../components/Stepper';
import { Step } from '../../../../../../components/Step';

import { useStepper } from '../../../../../../hooks/useStepper';

const steps = [
  LoginByPhoneFormStep1,
  LoginByPhoneFormStep2,
  LoginByPhoneFormStep3,
];

export type LoginByPhoneFormStepperProps = {
  onComplete?: Function;
};
export const LoginByPhoneFormStepper = ({
  onComplete = () => {},
}: LoginByPhoneFormStepperProps) => {
  const stepper = useStepper(steps);

  useEffect(() => {
    if (!stepper.isCompleted) {
      return;
    }
    onComplete();
  }, [
    onComplete,
    stepper.isCompleted,
  ]);

  if (stepper.isCompleted) {
    return null;
  }

  return (
    <Stepper
      activeStep={stepper.activeStep}
    >
      {steps.map(StepContent => (
        <Step
          key={StepContent.toString()}
        >
          <StepContent
            {...stepper}
          />
        </Step>
      ))}
    </Stepper>
  );
};
